// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { sparseItemSchema } from '@/sparse/api/types';
import { z } from 'zod';

const BUNDLE_MEMBERS_REQUIRED_MESSAGE = 'A bundle needs at least one item';

/**
 * One editable member row in the bundle members form.
 * Rows start with a null item; submit requires every row to have one.
 */
const bundleMemberFormValueSchema = z.object({
  item: sparseItemSchema.nullable().refine((item) => item !== null, {
    message: 'Select an item',
  }),
  quantity: z
    .number({ invalid_type_error: 'Enter a quantity' })
    .int('Quantity must be a whole number')
    .min(1, 'Quantity must be at least 1'),
});

export type BundleMemberFormValue = z.infer<typeof bundleMemberFormValueSchema>;

/**
 * The ordered member list; a bundle can never be saved empty.
 */
export const bundleMembersFormSchema = z
  .array(bundleMemberFormValueSchema)
  .min(1, BUNDLE_MEMBERS_REQUIRED_MESSAGE);
